import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUrlQuerysection } from "../../../../../../helpers";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { useGetRestockLogs } from "../../../../../../hooks/api/queries";

export const useRestockLogs = () => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByDate,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [isModal, setIsModal] = useState(false);
  const navigate = useNavigate();

  const {
    isLoading: isFetchingStockHistory,
    data: stockHistory,
    refetch: handleFetchStockHistory,
  } = useGetRestockLogs({ queries });

  const filterByStockTpye = (type) => {
    if (!type) search.delete("type");
    else search.set("type", type);
    search.delete("page");
    setSearch(search, { replace: true });
  };
  return {
    isFetchingStockHistory,
    storeList,
    metaDetails: stockHistory?.meta || {},
    stockHistory: stockHistory?.data || [],
    search,
    isModal,
    setSearch,
    filterBySearch,
    filterByDate,
    setIsModal,
    handleFetchStockHistory,
    filterByStoreId,
    gotoPage,
    navigate,
    filterByStockTpye,
  };
};
